import moment from 'moment';

export function useFreeFormtoString(detail, lang = 'en', logo, width) {
    const freeFormTopic = detail?.freeFormPolicy.freeFormPolicyNameTh;
    const freeFormTopicEn = detail?.freeFormPolicy.freeFormPolicyNameEn;
    const date = moment(detail?.logDate).format('DD-MM-YYYY');
    const topic = lang === 'en' ? freeFormTopicEn : freeFormTopic;
    const freeFormIntroductionTh = detail?.freeFormPolicy.freeFormIntroductionTh;
    const freeFormIntroductionEn = detail?.freeFormPolicy.freeFormIntroductionEn;
    const fileName =
        lang === 'en'
            ? `${freeFormTopicEn}_${date}_${lang.toUpperCase()}.docx`
            : `${freeFormTopic}_${date}_${lang.toUpperCase()}.docx`;
    return {
        html: `
        <html>
        <head>
            <meta charset="UTF-8" />
            <title>Document</title>
            <script type="text/javascript" src="https://ajax.googleapis.com/ajax/libs/jquery/1.6.2/jquery.min.js"></script>
            <script src="https://cdnjs.cloudflare.com/ajax/libs/FileSaver.js/2.0.5/FileSaver.min.js"></script>
            <script src="https://evidenceprime.github.io/html-docx-js/build/html-docx.js"></script>
        </head>
        <body style="word-break: break-word;">
         <center>
        ${logo &&
        `<img
            width="${width}"
             height="100"
        style="object-fit: cover;"
        src=${logo}
        alt="logo "/>`
        }</center>
        <center><h3>${topic}</h3></center>
        <p className="indent-8 text-left">
            ${
                // hrIntroductionLawfulBasis?.hrIntroductionIsDisplay === true
                    // lang === 'TH' && freeFormIntroductionTh
                    //     ? freeFormIntroductionTh 
                    //     :  lang === 'EN' && freeFormIntroductionEn ? freeFormIntroductionEn : null
                    // : ''
                lang === 'th'
                    ? freeFormIntroductionTh && freeFormIntroductionTh
                    : freeFormIntroductionEn && freeFormIntroductionEn
            }
        </p>
       ${
           detail?.freeFormDataList.sort((a, b) => a.sequence - b.sequence)
               ?.map(
                   (item) =>
                       `<div><h4>${
                           lang === 'en'
                               ? item.freeFormTitleEn
                               : item.freeFormTitleTh
                       }</h4>${
                           lang === 'en'
                               ? item.freeFormContentEn
                               : item.freeFormContentTh || '-'
                       }</div>`
               )
               .join(' ') || ''
       }
        <script type="text/javascript">
                $(document).ready(function() {
                let allElements = $('*');
                let converted = htmlDocx.asBlob(allElements.html());
                saveAs(converted, '${fileName}');
                setTimeout(()=> window.close(), 100)
                });
        </script>
    </body>
</html>`,
    };
}
